"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Used for the forecast dummy Window / WindowItem creation.
 * @author BPo
 */


var DummyWindowAppendDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DummyWindowAppendDTO, _DomainObject_1$Domai);

  function DummyWindowAppendDTO(dummyWindowId, volume, promoPrice, promoPurchasePrice) {
    var _this;

    _classCallCheck(this, DummyWindowAppendDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowAppendDTO).call(this));
    _this.dummyWindowId = dummyWindowId;
    _this.volume = volume;
    _this.promoPrice = promoPrice;
    _this.promoPurchasePrice = promoPurchasePrice;
    return _this;
  }

  return DummyWindowAppendDTO;
}(DomainObject_1.DomainObject);

exports.DummyWindowAppendDTO = DummyWindowAppendDTO;

DummyWindowAppendDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DummyWindowAppendDTO.name);
  return {
    dummyWindowId: builder.id('dummyWindowId'),
    volume: builder.bigNum('volume'),
    promoPrice: builder.bigNum('promoPrice'),
    promoPurchasePrice: builder.bigNum('promoPurchasePrice')
  };
}();